
import state from '../store/state.js';
// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢
const _import = require('./import-' + process.env.NODE_ENV)

function getProps(route) {
  return route.query;
}

// 系统生成路由
const routers = [
  { path: '/login', component: _import('login/index'), name: 'login', props: getProps, desc: '登录' },
  {
    path: '/',
    component: _import('login/index'),
    name: 'root'
  },
  // 所有components页面
  {
    path: '/components',
    component: _import('layout/index'),
    name: 'components',
    props: getProps,
    redirect: {
      name: 'components'
    },
    meta: {
      title: '隐藏页面',
      showOnly: false
      // keepAlive: false
    },
    children: [

    ]
  },
  {
    path: '/main',
    component: _import('layout/index'),
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome'
    },
    meta: {
      title: '主页',
      showOnly: true,
      
    },
    children: [
      { path: 'formSysUser', component: _import('upms/formSysUser/index'), name: 'formSysUser', meta: { title: '用户管理' } },
      { path: 'formSysDept', component: _import('upms/formSysDept/index'), name: 'formSysDept', meta: { title: '部门管理' } },
      { path: 'formSysRole', component: _import('upms/formSysRole/index'), name: 'formSysRole', meta: { title: '角色管理' } },
      { path: 'formSysDataPerm', component: _import('upms/formSysDataPerm/index'), name: 'formSysDataPerm', meta: { title: '数据权限管理' } },
      { path: 'formSysMenu', component: _import(state.supportColumn ? 'upms/formSysMenu/formSysColumnMenu' : 'upms/formSysMenu/index'), name: 'formSysMenu', meta: { title: '菜单列表' } },
      { path: 'formSysDict', component: _import('upms/formDictManagement/index'), name: 'formSysDict', meta: { title: '字典管理' } },
      { path: 'formSysPermCode', component: _import('upms/formSysPermCode/index'), name: 'formSysPermCode', meta: { title: '权限字管理' } },
      { path: 'formSysPerm', component: _import('upms/formSysPerm/index'), name: 'formSysPerm', meta: { title: '权限资源管理' } },
      { path: 'formSysOperationLog', component: _import('upms/formSysOperationLog/index'), name: 'formSysOperationLog', meta: { title: '操作日志' } },
      { path: 'formSysLoginUser', component: _import('upms/formSysLoginUser/index'), name: 'formSysLoginUser', meta: { title: '在线用户' } },

      // 供应商
      { path: 'supplier_basic', component: _import('supplier/basic'), name: 'supplier_basic', meta: { title: '基本资料',  } },
      { path: 'supplier_qualifications', component: _import('supplier/qualifications'), name: 'supplier_qualifications', meta: { title: '资质认证',  } },
      { path: 'supplier_contract', component: _import('supplier/contract'), name: 'supplier_contract', meta: { title: '基本合同',  } },
      { path: 'supplier_printModel', component: _import('supplier/printModel'), name: 'supplier_printModel', meta: { title: '打印配置',  } },
      { path: 'print_printSystem', component: _import('supplier/printSystem'), name: 'print_printSystem', meta: { title: '打印模板',  } },
      // 采购报价
      { path: 'quotation_inquiry', component: _import('quotation/inquiry'), name: 'quotation_inquiry', meta: { title: '询价单',  } },
      // 采购
      { path: 'purchase_order', component: _import('purchase/order'), name: 'purchase_order', meta: { title: '采购订单',  } },
      { path: 'purchase_storage', component: _import('purchase/storage'), name: 'purchase_storage', meta: { title: '采购收货',  } },
      { path: 'purchase_return', component: _import('purchase/return'), name: 'purchase_return', meta: { title: '采购退货',  } },
      // 对账
      { path: 'reconciliation_bill', component: _import('reconciliation/bill'), name: 'reconciliation_bill', meta: { title: '对账单',  } },
      { path: 'reconciliation_unBill', component: _import('reconciliation/unBill'), name: 'reconciliation_unBill', meta: { title: '未对账',  } },
      // 产品委外
      { path: 'outsourcingProduct_order', component: _import('outsourcingProduct/order'), name: 'outsourcingProduct_order', meta: { title: '产品委外订单',  } },
      { path: 'outsourcingProduct_materials', component: _import('outsourcingProduct/materials'), name: 'outsourcingProduct_materials', meta: { title: '产品委外发料单',  } },
      { path: 'outsourcingProduct_return', component: _import('outsourcingProduct/return'), name: 'outsourcingProduct_return', meta: { title: '产品委外退料单',  } },
      { path: 'outsourcingProduct_finish', component: _import('outsourcingProduct/finish'), name: 'outsourcingProduct_finish', meta: { title: '产品委外收货单',  } },
      { path: 'outsourcingProduct_warehouse', component: _import('outsourcingProduct/warehouse'), name: 'outsourcingProduct_warehouse', meta: { title: '协同库存仓',  } },
      { path: 'outsourcingProduct_warehouseOverview', component: _import('outsourcingProduct/warehouseOverview'), name: 'outsourcingProduct_warehouseOverview', meta: { title: '委外库存总览',  } },
      { path: 'outsourcingProduct_warehouseSummary', component: _import('outsourcingProduct/warehouseSummary'), name: 'outsourcingProduct_warehouseSummary', meta: { title: '委外库存汇总',  } },
      { path: 'outsourcingProduct_warehouseFlow', component: _import('outsourcingProduct/warehouseFlow'), name: 'outsourcingProduct_warehouseFlow', meta: { title: '委外库存流水',  } },
      { path: 'outsourcingProduct_warehouseBatchInventory', component: _import('outsourcingProduct/warehouseBatchInventory'), name: 'outsourcingProduct_warehouseBatchInventory', meta: { title: '批次库存台账',  } },
      { path: 'outsourcingProduct_statement', component: _import('outsourcingProduct/statement'), name: 'outsourcingProduct_statement', meta: { title: '委外对账单',  } },
      // 工序委外
      { path: 'outsourcingProcesses_order', component: _import('outsourcingProcesses/order'), name: 'outsourcingProcesses_order', meta: { title: '工序委外订单',  } },
      { path: 'outsourcingProcesses_materials', component: _import('outsourcingProcesses/materials'), name: 'outsourcingProcesses_materials', meta: { title: '工序委外发料单',  } },
      { path: 'outsourcingProcesses_return', component: _import('outsourcingProcesses/return'), name: 'outsourcingProcesses_return', meta: { title: '工序委外退料单',  } },
      { path: 'outsourcingProcesses_finish', component: _import('outsourcingProcesses/finish'), name: 'outsourcingProcesses_finish', meta: { title: '工序委外收货单',  } },
      { path: 'outsourcingProcesses_warehouse', component: _import('outsourcingProcesses/warehouse'), name: 'outsourcingProcesses_warehouse', meta: { title: '协同库存仓',  } },
      { path: 'outsourcingProcesses_warehouseFlow', component: _import('outsourcingProcesses/warehouseFlow'), name: 'outsourcingProcesses_warehouseFlow', meta: { title: '委外库存流水',  } },
      { path: 'outsourcingProcesses_warehouseBatchInventory', component: _import('outsourcingProcesses/warehouseBatchInventory'), name: 'outsourcingProcesses_warehouseBatchInventory', meta: { title: '批次库存台账',  } },
      {
        path: 'handlerFlowTask',
        component: _import('workflow/handlerFlowTask/index'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: { title: '流程处理' },
        children: [
          // 静态表单路由设置
        ]
      },
      { path: 'welcome', component: _import('welcome/index'), name: 'welcome', meta: { title: '欢迎' } },
      { path: 'workbench', component: _import('workbench/index'), name: 'workbench', meta: { title: '协同工作台' } },
    ]
  },
  // 自定义第三方路由  // 第三方接入路由
  {
    path: '/thirdParty',
    name: 'thirdParty',
    props: getProps,
    component: _import('thirdParty/index'),
    children: [
      // 流程分类列表
      {
        path: 'thirdFormFlowCategory',
        name: 'thirdFormFlowCategory',
        props: getProps,
        component: _import('workflow/flowCategory/formFlowCategory')
      },
      // 流程分类 新增、编辑
      {
        path: 'thirdAddFormFlowCategory',
        name: 'thirdAddFormFlowCategory',
        props: getProps,
        component: _import('workflow/flowCategory/formEditFlowCategory')
      },
      // 流程实例列表
      {
        path: 'thirdFormAllInstance',
        name: 'thirdFormAllInstance',
        props: getProps,
        component: _import('workflow/taskManager/formAllInstance')
      },
      // 流程图
      {
        path: 'thirdFormTaskProcessViewer',
        name: 'thirdFormTaskProcessViewer',
        props: getProps,
        component: _import('workflow/taskManager/formTaskProcessViewer')
      },
      // 流程干涉
      {
        path: 'thirdFormInterposeInstance',
        name: 'thirdFormInterposeInstance',
        props: getProps,
        component: _import('workflow/taskManager/formInterposeInstance')
      },
      // 数据补偿
      {
        path: 'thirdFormCompensationInstance',
        name: 'thirdFormCompensationInstance',
        props: getProps,
        component: _import('workflow/taskManager/processCompensation')
      },
      // 流程终止
      {
        path: 'thirdFormStopTaskInstance',
        name: 'thirdFormStopTaskInstance',
        props: getProps,
        component: _import('workflow/taskManager/stopTask')
      },
      // 选择用户-处理用户
      {
        path: 'thirdTaskUserSelect',
        name: 'thirdTaskUserSelect',
        props: getProps,
        component: _import('workflow/components/TaskUserSelect')
      },
      // 选择用户-跳转节点
      {
        path: 'thirdSelectUserTask',
        name: 'thirdSelectUserTask',
        props: getProps,
        component: _import('workflow/components/UserTaskSelect/userTaskSelectDlg')
      },
      // 流程设计
      {
        path: 'thirdFormFlowEntry',
        name: 'thirdFormFlowEntry',
        props: getProps,
        component: _import('workflow/flowEntry/formFlowEntry')
      },
      {
        path: 'thirdFormEditFlowEntry',
        name: 'thirdFormEditFlowEntry',
        props: getProps,
        component: _import('workflow/flowEntry/formEditFlowEntry')
      },
      {
        path: 'thirdFormPublishedFlowEntry',
        name: 'thirdFormPublishedFlowEntry',
        props: getProps,
        component: _import('workflow/flowEntry/formPublishedFlowEntry')
      },
      {
        path: 'thirdHandlerFlowTask',
        name: 'thirdHandlerFlowTask',
        props: getProps,
        component: _import('workflow/handlerFlowTask/index')
      },
      // 流程设计-候选用户组
      {
        path: 'thirdTaskGroupSelect',
        name: 'thirdTaskGroupSelect',
        props: getProps,
        component: _import('workflow/components/TaskGroupSelect')
      },
      // 流程设计-选择岗位
      {
        path: 'thirdTaskPostSelect',
        name: 'thirdTaskPostSelect',
        props: getProps,
        component: _import('workflow/components/TaskPostSelect')
      },
      // 流程设计-抄送
      {
        path: 'thirdAddCopyForItem',
        name: 'thirdAddCopyForItem',
        props: getProps,
        component: _import('workflow/components/CopyForSelect/addCopyForItem')
      },
      // 流程设计-抄送
      {
        path: 'thirdEditOperation',
        name: 'thirdEditOperation',
        props: getProps,
        component: _import('workflow/package/refactor/form/formEditOperation')
      },
      // 流程设计-添加变量
      {
        path: 'thirdFormEditFlowEntryVariable',
        name: 'thirdFormEditFlowEntryVariable',
        props: getProps,
        component: _import('workflow/flowEntry/formEditFlowEntryVariable')
      },
      // 流程设计-新建状态
      {
        path: 'thirdFormEditFlowEntryStatus',
        name: 'thirdFormEditFlowEntryStatus',
        props: getProps,
        component: _import('workflow/flowEntry/formEditFlowEntryStatus')
      },
      // 流程设计-新建状态
      {
        path: 'thirdTaskCommit',
        name: 'thirdTaskCommit',
        props: getProps,
        component: _import('workflow/components/TaskCommit')
      },
      // 待办任务
      {
        path: 'thirdFormMyTask',
        name: 'thirdFormMyTask',
        props: getProps,
        component: _import('workflow/taskManager/formMyTask')
      },
      // 历史任务
      {
        path: 'thirdFormMyHistoryTask',
        name: 'thirdFormMyHistoryTask',
        props: getProps,
        component: _import('workflow/taskManager/formMyHistoryTask')
      },
      // 已办任务
      {
        path: 'thirdFormMyApprovedTask',
        name: 'thirdFormMyApprovedTask',
        props: getProps,
        component: _import('workflow/taskManager/formMyApprovedTask')
      },
      // 通用
      {
        path: 'thirdEditDictParamValue2',
        name: 'thirdEditDictParamValue2',
        props: getProps,
        component: _import('components/WidgetAttributeSetting/components/CustomWidgetDictSetting/editDictParamValue', 'online')
      },
      {
        path: 'thirdEditOnlineTableColumn2',
        name: 'thirdEditOnlineTableColumn2',
        props: getProps,
        component: _import('components/WidgetAttributeSetting/components/OnlineTableColumnSetting/editOnlineTableColumn', 'online')
      },
      {
        path: 'thirdEditOnlineTabPanel2',
        name: 'thirdEditOnlineTabPanel2',
        props: getProps,
        component: _import('components/WidgetAttributeSetting/components/OnlineTabPanelSetting/editOnlineTabPanel', 'online')
      },
      {
        path: 'thirdSelectDept',
        name: 'thirdSelectDept',
        props: getProps,
        component: _import('DeptSelect/deptSelectDlg', 'components')
      },
      {
        path: 'thirdSelectUser',
        name: 'thirdSelectUser',
        props: getProps,
        component: _import('UserSelect/userSelectDlg', 'components')
      },
      {
        path: 'thirdSelectData',
        name: 'thirdSelectData',
        props: getProps,
        component: _import('components/OnlineCustomDataSelect/dataSelectDlg', 'online')
      },
      {
        path: 'thirdEditCustomEvent',
        name: 'thirdEditCustomEvent',
        props: getProps,
        component: _import('components/CustomEventSetting/editCustomEvent', 'online')
      }
    ]
  }
];

export default routers;
